<template>
  <b-card no-body>
    <b-card-header v-if="message[userKey]" class="email-detail-head">
      <div
        class="user-details d-flex justify-content-between align-items-center flex-wrap"
      >
        <b-avatar size="48" cla :src="message[userKey].logo" class="mr-75" />
        <div class="mail-items">
          <h5 class="mb-0 mail-ngo-name">
            {{ message[userKey].name_ar || message[userKey].branch }}
          </h5>
          <small class="mail-user-name"> {{ message.user.full_name }} </small>
          <!-- <b-dropdown
            variant="link"
            no-caret
            toggle-class="p-0"
            class="email-info-dropup"
          >
            <template #button-content>
              <span class="font-small-3 text-muted mr-25">{{ message.from.email }}</span>
              <feather-icon
                icon="ChevronDownIcon"
                size="10"
              />
            </template>
            <table class="table table-sm table-borderless font-small-3">
              <tbody>
                <tr>
                  <td class="text-right text-muted align-top">
                    From:
                  </td>
                  <td>{{ message.from.email }}</td>
                </tr>
                <tr>
                  <td class="text-right text-muted align-top">
                    To:
                  </td>
                  <td>{{ message.to.map(receiver => receiver.email).join(', ') }}</td>
                </tr>
                <tr>
                  <td class="text-right text-muted align-top">
                    Date:
                  </td>
                  <td>4:25 AM 13 Jan 2018</td>
                </tr>
              </tbody>
            </table>
          </b-dropdown> -->
        </div>
      </div>
      <div class="mail-meta-item d-flex align-items-center">
        <small class="mail-date-time text-muted">{{
          message.updated_at
            ? formatDateToHuman(message.updated_at)
            : formatDateToHuman(message.created_at)
        }}</small>
        <!-- Mail Action DD -->
      </div>
    </b-card-header>

    <b-card-body class="mail-message-wrapper pt-2">
      <!-- eslint-disable vue/no-v-html -->
      <div class="mail-message" v-html="message.content" />
      <!-- eslint-enable -->
    </b-card-body>

    <b-card-footer v-if="message.attachments && message.attachments.length">
      <div class="mail-attachments">
        <div class="d-flex align-items-center mb-1">
          <feather-icon icon="PaperclipIcon" size="16" />
          <h5 class="font-weight-bolder text-body mb-0 ml-50">
            {{ message.attachments.length }} مرفقات
          </h5>
        </div>

        <div class="d-flex w-100 overflow-auto">
          <router-link target="_blank" class="h5 text-primary mb-0"
            >تحميل الملف</router-link
          >
          <b-link
            v-for="(attachment, index) in message.attachments"
            :key="index"
            :to="{ name: 'file-view', query: { ep: attachment.source } }"
            target="_blank"
            class="m-50 d-flex flex-column align-items-center message-attachment"
          >
            <feather-icon size="40" icon="FileTextIcon" />
            <div class="text-center mt-50">
              {{ `مرفق ${index + 1}` }}
            </div>
          </b-link>
        </div>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BCardFooter,
  BAvatar,
  BLink,
  BImg,
} from "bootstrap-vue";
import { formatDateToHuman } from "@core/utils/filter";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    BCardFooter,
    BAvatar,
    BLink,
    BImg,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formatDateToHuman,
    };
  },
  computed: {
    userKey() {
      return this.message.sender ? "sender" : "replier";
    },
  },
};
</script>

<style lang="scss">
.message-attachment {
  padding: 10px;
  border-radius: 8px;
}
.message-attachment:hover {
  background-color: var(--light);
}
.dark-layout .message-attachment:hover {
  background-color: var(--dark);
}
</style>
